/**
 * Internal dependencies
 */
import { bold } from './bold';
import { italic } from './italic';
import { link } from './link';
import { strikethrough } from './strikethrough';
import { textColor } from './text-color';

export default [ bold, italic, link, strikethrough, textColor ];
